import { render, staticRenderFns } from "./confirmMsg.vue?vue&type=template&id=610da928"
import script from "./confirmMsg.vue?vue&type=script&lang=js"
export * from "./confirmMsg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports